import { useState } from 'react'
import { api, can, refusalReason, type VendorDocument } from '../lib/api'

// The "Auto-renews" box of an MSA or SOW (release 3.3, the plan's C14). A
// contract that renews itself raises a renewal notice before it ends and not
// an exit proposal: the exit-proposal query already skipped auto_renew, but
// nothing wrote it, so every filed contract raised one 90 days before its end.
// AutoRenewField sits on the upload form; AutoRenewBox on a contract already
// on file, where it saves at once (POST /v1/documents/{id}/auto-renew).

const NOTE = 'A renewing contract raises a renewal notice, not an offboarding proposal.'

export function AutoRenewField({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <div className="field auto-renew">
      <label htmlFor="vc-auto-renew">
        <input id="vc-auto-renew" type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} aria-describedby="vc-auto-renew-note" />
        Auto-renews
      </label>
      <p className="field-note" id="vc-auto-renew-note">
        {NOTE}
      </p>
    </div>
  )
}

export function AutoRenewBox({ doc, onSaved }: { doc: VendorDocument; onSaved: () => void }) {
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState('')
  const allowed = can('evidence.upload')
  const id = 'vc-renews-' + doc.id
  return (
    <span className="cell-sub auto-renew">
      <label htmlFor={id} title={allowed ? NOTE : refusalReason('evidence.upload')}>
        <input
          id={id}
          type="checkbox"
          checked={doc.autoRenews === true}
          disabled={busy || !allowed}
          onChange={(e) => {
            setBusy(true)
            setFailed('')
            api
              .setDocumentAutoRenew(doc.id, e.target.checked)
              .then(onSaved)
              .catch(() => setFailed('Not saved. Try again.'))
              .finally(() => setBusy(false))
          }}
        />
        Auto-renews
      </label>
      {failed && (
        <span className="field-error" role="alert">
          {failed}
        </span>
      )}
    </span>
  )
}
